<template>
  <div class="medical">
    <div class="title">{{$t('medical_page.title1')}}</div>
    <p>{{$t('medical_page.p1')}}</p>
    <div class="title">{{$t('medical_page.title2')}}</div>
    <div v-for="(item,index) in $t('medical_page.part2List')" :key="index">
      <div style="text-align:center">
        <img :src="require(`@/assets/medical/img${index}${$t('lang') === 'En' ? '-en':''}.png`)" alt="" style="width:93%;margin:auto">
      </div>
      <div class="sub-title">{{item.title}}</div>
      <p style="margin-bottom:40px">{{item.content}}</p>
    </div>
    <div class="title">{{$t('medical_page.title3')}}</div>
    <div v-for="(item,index) in $t('medical_page.part3List')" :key="index">
      <div class="sub-title">{{item.title}}</div>
      <p style="margin-bottom:40px">{{item.content}}</p>
    </div>
    <div class="title">{{$t('medical_page.title4')}}</div>
    <p>{{$t('medical_page.p4')}}</p>
    <div v-for="(item,index) in $t('medical_page.part4List')" :key="index">
      <div class="sub-title">{{item.title}}</div>
      <p style="margin-bottom:40px">{{item.content}}</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
}
</script>
<style lang="scss" scoped>
.medical {
  padding: 0 15vw;
  .title {
    padding-top: 40px;
    font-size: 28px;
    margin: 40px 0;
    font-weight: 600;
  }
  
  p {
    margin: 0;
    padding: 0;
    text-indent: 2em;
    font-size: 20px;
    line-height: 30px;
  }
  .sub-title {
    font-size: 20px;
    font-weight: 600;
    margin: 40px 0;
  }
}
</style>